(function(){
  const tag=document.currentScript.dataset.consentTag;
  if(customElements.get(tag)) return;
  class ConsentPdf extends HTMLElement {
    connectedCallback(){
      const path=location.pathname.replace(/\/+$/,'');
      if(!/(^|\/)pages\/childrens-artwork-publication-consent$/.test(path)) return;
      this.button=this.querySelector('button'); this.status=this.querySelector('[role="status"]');
      this.snapshot=null; this.succeeded=false; this.observer=null;
      this.button.addEventListener('click',()=>{ if(this.snapshot) this.download(this.snapshot); });
      if(this.dataset.editorTest==='true' || (window.Shopify && window.Shopify.designMode)){
        this.snapshot={
          data:[['Document type','EDITOR TEST ONLY - not a submitted consent'],['Name','Test Parent'],['Email','test@example.com'],['Arabic rendering test','هذه بيانات تجريبية فقط'],['German rendering test','Dies ist nur ein Test.']],
          clauses:['This sample PDF tests document generation only. It is not proof of a form submission or consent.'],
          files:[],locale:this.locale(),
          date:new Intl.DateTimeFormat(this.locale(),{year:'numeric',month:'long',day:'numeric'}).format(new Date())
        };
        this.hidden=false;
        this.querySelector('h2').textContent='Consent PDF test — theme editor only';
        this.querySelector('p').textContent='Download a sample PDF with fictional data. No form is submitted.';
        this.button.textContent='Download test PDF';
        this.status.textContent='Editor test ready. Fictional data only.';
        return;
      }
      this.attachWhenReady();
    }
    attachWhenReady(){
      let attempts=0;
      const find=()=>{
        const embeds=[...document.querySelectorAll('shopify-forms-embed')];
        const scoped=document.querySelector('[id^="shopify-section-"][id$="__forms"]');
        const scopedEmbeds=scoped?[...scoped.querySelectorAll('shopify-forms-embed')]:[];
        const embed=embeds.find(el=>{const s=el.shadowRoot; return s && (el.getAttribute('data-form-id')==='1202806' || el.getAttribute('id')?.includes('1202806') || s.innerHTML.includes('1202806') || (scopedEmbeds.length===1 && scopedEmbeds[0]===el));});
        if(embed){ return this.watch(embed); }
        return false;
      };
      if(find()) return;
      const timer=setInterval(()=>{attempts++; if(find()||attempts>=40) clearInterval(timer);},500);
    }
    watch(embed){
      const root=embed.shadowRoot;
      const exact=()=>[...root.querySelectorAll('[data-form-id],form,[id]')].find(el=>[el.getAttribute('data-form-id'),el.id,el.getAttribute('action'),el.getAttribute('name')].filter(Boolean).some(v=>v.includes('1202806')));
      const target=exact();
      const form=target?.matches('form')?target:target?.querySelector('form')||root.querySelector('form');
      if(!form) return false;
      const capture=event=>{
        const current=event.target.closest?.('form');
        if(current && !this.succeeded && current.checkValidity()) this.snapshot=this.collect(current,root);
      };
      root.addEventListener('submit',capture,true);
      root.addEventListener('click',event=>{
        const submit=event.target.closest?.('button[type="submit"],input[type="submit"]');
        if(submit?.form && submit.form.checkValidity() && !this.succeeded) this.snapshot=this.collect(submit.form,root);
      },true);
      this.observer=new MutationObserver(()=>{
        if(this.succeeded) return;
        const failure=[...root.querySelectorAll('[aria-invalid="true"], [role="alert"]')].some(el=>el.getClientRects().length>0 && (el.getAttribute('aria-invalid')==='true' || el.textContent.trim()));
        const successStep=root.querySelector('[data-current-step="success"], [data-step="success"], [data-testid="form-success"]');
        const visibleSuccess=successStep && !successStep.closest('[hidden], [aria-hidden="true"]') && successStep.getClientRects().length>0;
        const headings=[...root.querySelectorAll('h1,h2,h3,[role="heading"]')];
        const exactHeading=headings.some(el=>el.getClientRects().length>0 && el.textContent.trim().toLowerCase()==='consent submitted');
        const confirmed=Boolean(visibleSuccess || (exactHeading && !root.querySelector('form')));
        if(confirmed&&!failure&&this.snapshot){ this.succeeded=true; this.hidden=false; this.download(this.snapshot); }
      });
      this.observer.observe(root,{subtree:true,childList:true,characterData:true,attributes:true});
      return true;
    }
    collect(form,root){
      const data=[];
      const clean=text=>String(text||'').replace(/\s+/g,' ').trim();
      const labelled=node=>(node.getAttribute('aria-labelledby')||'').split(/\s+/).filter(Boolean).map(id=>clean(root.getElementById(id)?.textContent)).filter(Boolean).join(' ');
      const labels=el=>[...(el.labels||[])].map(label=>clean(label.innerText)).filter(Boolean).join(', ');
      const groups=new Map();
      [...form.querySelectorAll('input,select,textarea')].forEach(el=>{
        if(['hidden','submit','button','password'].includes(el.type)||el.disabled) return;
        if(el.type==='file'){
          const selected=[...(el.files||[])];
          if(selected.length){
            const heading=labels(el)||labelled(el)||el.getAttribute('aria-label')||clean(el.closest('fieldset')?.querySelector('legend')?.innerText)||'Uploaded image';
            data.push([heading,selected.map(file=>file.name),[],selected]);
          }
          return;
        }
        const choice=['checkbox','radio'].includes(el.type);
        const fieldset=el.closest('fieldset');
        let question='';
        if(choice && fieldset){
          const legend=fieldset.querySelector('legend');
          question=clean(legend?.innerText)||labelled(fieldset);
          if(!question){
            const title=[...fieldset.querySelectorAll('label,[class*="fieldLabel"],[class*="FieldLabel"],h3,h4')].find(node=>!node.querySelector('input')&&!node.htmlFor&&!node.closest('label[for]'));
            question=clean(title?.innerText);
          }
          if(!question){
            const copy=fieldset.cloneNode(true);
            copy.querySelectorAll('label,input,select,textarea,button,[role="alert"]').forEach(node=>node.remove());
            question=clean(copy.textContent);
          }
        }
        question=question||(!choice?labels(el):'')||labelled(el)||el.getAttribute('aria-label')||clean((fieldset?.getAttribute('name')||el.name||'Question').replace(/^custom[#: _-]*/,'').replace(/_/g,' '));
        let value=el.tagName==='SELECT'?[...el.selectedOptions].map(option=>clean(option.textContent)).join(', '):el.value;
        if(choice){value=labels(el)||clean(el.value);}
        value=clean(value);
        if(!value) return;
        const key=choice?(fieldset||el.name||el):el;
        if(!groups.has(key)){const row=[question,[],[]];groups.set(key,row);data.push(row);}
        const row=groups.get(key);
        if(choice){
          row[2].push({label:value,type:el.type,checked:el.checked});
          if(el.checked&&!row[1].includes(value))row[1].push(value);
        }else if(!row[1].includes(value)){row[1].push(value);}
      });
      data.forEach(row=>{row[1]=row[1].join('\n');});
      const clauses=[];
      const files=[...form.querySelectorAll('input[type="file"]')].flatMap(el=>[...(el.files||[])]);

      return {data,clauses,files,locale:this.getAttribute('data-locale'),date:new Intl.DateTimeFormat(this.locale(),{year:'numeric',month:'long',day:'numeric'}).format(new Date())};
    }
    locale(){const code=(this.getAttribute('data-locale')||'').toLowerCase(); if(code.startsWith('ar')) return 'ar'; if(code.startsWith('de')) return 'de'; return 'en';}
    async download(record){
      try{
        const rtl=record.locale==='ar'; const canvas=document.createElement('canvas'); canvas.width=1240; canvas.height=1754;
        const ctx=canvas.getContext('2d'); const pages=[]; let y=100;
        let logo=null;
        const logoUrl=this.dataset.logoUrl;
        if(logoUrl){logo=new Image();logo.crossOrigin='anonymous';await new Promise((resolve,reject)=>{logo.onload=resolve;logo.onerror=()=>reject(new Error('Store logo could not be loaded'));logo.src=logoUrl;});}
        const drawPage=()=>{
          ctx.fillStyle='#fff';ctx.fillRect(0,0,canvas.width,canvas.height);
          if(logo){const scale=Math.min(280/logo.naturalWidth,92/logo.naturalHeight);const width=logo.naturalWidth*scale;ctx.drawImage(logo,(canvas.width-width)/2,38,width,logo.naturalHeight*scale);}
          ctx.fillStyle='#e2eeeb';ctx.fillRect(80,150,1080,3);
          ctx.fillStyle='#52635f';ctx.font='20px sans-serif';ctx.textAlign='right';ctx.direction='ltr';ctx.fillText('EMKIDO  |  '+(pages.length+1),1160,1695);
          ctx.fillStyle='#171717';ctx.textAlign=rtl?'right':'left';ctx.direction=rtl?'rtl':'ltr';y=210;
        };
        drawPage();
        const add=(text,bold,option=null)=>{
          const maxWidth=option?990:1040;
          const font=(bold?'bold ':'')+(bold?'29':'27')+'px sans-serif';ctx.font=font;
          const lines=[];
          String(text).split(/\n/).forEach(paragraph=>{
            let line='';
            paragraph.split(/\s+/).filter(Boolean).forEach(word=>{
              if(ctx.measureText(word).width>maxWidth){
                if(line){lines.push(line);line='';}
                for(const character of word){if(ctx.measureText(line+character).width>maxWidth){lines.push(line);line='';}line+=character;}
              }else{const test=line?line+' '+word:word;if(ctx.measureText(test).width>maxWidth&&line){lines.push(line);line=word;}else line=test;}
            });
            if(line)lines.push(line);
          });
          lines.forEach((row,index)=>{
            if(y>1580){pages.push(canvas.toDataURL('image/jpeg',0.92));drawPage();}
            if(option&&index===0){
              const x=rtl?1114:100;const top=y-24;const size=25;
              ctx.save();ctx.strokeStyle='#303a37';ctx.lineWidth=2;ctx.fillStyle='#183f39';ctx.beginPath();
              if(option.type==='radio'){
                ctx.arc(x+size/2,top+size/2,size/2,0,Math.PI*2);ctx.stroke();
                if(option.checked){ctx.beginPath();ctx.arc(x+size/2,top+size/2,7,0,Math.PI*2);ctx.fill();}
              }else{
                ctx.strokeRect(x,top,size,size);
                if(option.checked){ctx.lineWidth=3;ctx.beginPath();ctx.moveTo(x+5,top+13);ctx.lineTo(x+10,top+19);ctx.lineTo(x+21,top+6);ctx.stroke();}
              }
              ctx.restore();
            }
            ctx.font=font;ctx.fillStyle=bold?'#183f39':'#303a37';ctx.fillText(row,rtl?(option?1090:1140):(option?150:100),y);y+=41;
          });y+=14;
        };
        add('Children’s Artwork Publication Consent',true);
        add(this.getAttribute('data-date-label')+': '+record.date,false);y+=18;
        for(const pair of record.data){
          if(pair[3]?.length){
            for(const file of pair[3]){
              if(!file.type.startsWith('image/')){
                if(y>1450){pages.push(canvas.toDataURL('image/jpeg',0.92));drawPage();}
                add(pair[0],true);add(file.name,false);continue;
              }
              const imageUrl=URL.createObjectURL(file);
              try{
                const image=new Image();
                await new Promise((resolve,reject)=>{image.onload=resolve;image.onerror=reject;image.src=imageUrl;});
                const scale=Math.min(1040/image.naturalWidth,1050/image.naturalHeight);
                add(pair[0],true);add(file.name,false);
                const available=Math.max(1,1580-y-35);
                const finalScale=Math.min(scale,available/image.naturalHeight);
                const width=image.naturalWidth*finalScale;
                ctx.drawImage(image,rtl?1140-width:100,y,width,image.naturalHeight*finalScale);
                y+=image.naturalHeight*finalScale+30;
              }finally{URL.revokeObjectURL(imageUrl);}
            }
          }else{
            if(y>1450){pages.push(canvas.toDataURL('image/jpeg',0.92));drawPage();}
            add(pair[0],true);
            if(pair[2]?.length){pair[2].forEach(option=>add(option.label,false,option));}
            else{add(pair[1],false);}
          }
          ctx.fillStyle='#e2eeeb';ctx.fillRect(100,y,1040,1);y+=28;
        }
        if(record.clauses?.length){add(this.getAttribute('data-consent-label'),true);record.clauses.forEach(text=>add(text,false));}
        pages.push(canvas.toDataURL('image/jpeg',0.92));
        const blob=this.makePdf(pages,canvas.width,canvas.height);const url=URL.createObjectURL(blob);const a=document.createElement('a');a.href=url;a.download=(window.Shopify && window.Shopify.designMode)?'consent-copy-EDITOR-TEST.pdf':'consent-copy.pdf';document.body.appendChild(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),30000);
        this.status.textContent=this.locale()==='de'?'PDF wird heruntergeladen.':this.locale()==='ar'?'يجري تنزيل ملف PDF.':'The PDF download has started.';
      }catch(e){this.status.textContent=this.locale()==='de'?'Download fehlgeschlagen. Bitte erneut versuchen.':this.locale()==='ar'?'تعذر التنزيل. حاول مرة أخرى.':'Download failed. Please try again.';}
    }
    makePdf(images,w,h){
      const objects=[];const add=o=>objects.push(o);const pageIds=[];const imageIds=[];const contentIds=[];
      add('<< /Type /Catalog /Pages 2 0 R >>');add('');
      images.forEach((uri,i)=>{const raw=atob(uri.split(',')[1]);let bytes='';for(let j=0;j<raw.length;j++)bytes+=String.fromCharCode(raw.charCodeAt(j));const imgId=objects.length+1;add('<< /Type /XObject /Subtype /Image /Width '+w+' /Height '+h+' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length '+bytes.length+' >>\nstream\n'+bytes+'\nendstream');imageIds.push(imgId);const stream='q\n595 0 0 842 0 0 cm\n/Im'+i+' Do\nQ';const cId=objects.length+1;add('<< /Length '+stream.length+' >>\nstream\n'+stream+'\nendstream');contentIds.push(cId);pageIds.push(objects.length+1);add('<< /Type /Page /Parent 2 0 R /MediaBox [0 0 595 842] /Resources << /XObject << /Im'+i+' '+imgId+' 0 R >> >> /Contents '+cId+' 0 R >>');});
      objects[1]='<< /Type /Pages /Kids ['+pageIds.map(id=>id+' 0 R').join(' ')+'] /Count '+pageIds.length+' >>';let pdf='%PDF-1.4\n',offsets=[0];objects.forEach((o,i)=>{offsets.push(pdf.length);pdf+=(i+1)+' 0 obj\n'+o+'\nendobj\n';});const xref=pdf.length;pdf+='xref\n0 '+(objects.length+1)+'\n0000000000 65535 f \n';for(let i=1;i<offsets.length;i++)pdf+=String(offsets[i]).padStart(10,'0')+' 00000 n \n';pdf+='trailer\n<< /Size '+(objects.length+1)+' /Root 1 0 R >>\nstartxref\n'+xref+'\n%%EOF';const output=new Uint8Array(pdf.length);for(let i=0;i<pdf.length;i++)output[i]=pdf.charCodeAt(i)&255;return new Blob([output],{type:'application/pdf'});
    }
  }
  customElements.define(tag,ConsentPdf);
})();
